/**
 * @generated SignedSource<<ae6bc82047adc267cce178e29730d705>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ReportHubDetailedSkillReportByUnitsRowsQuery$variables = {
  classIds: ReadonlyArray<string>;
  skip?: boolean | null | undefined;
  standardStateId: string;
  targetGroupId: string;
};
export type ReportHubDetailedSkillReportByUnitsRowsQuery$data = {
  readonly transposedSkillProgressReportGroupedByUnitsInBytes?: {
    readonly data: ReadonlyArray<any>;
  };
};
export type ReportHubDetailedSkillReportByUnitsRowsQuery = {
  response: ReportHubDetailedSkillReportByUnitsRowsQuery$data;
  variables: ReportHubDetailedSkillReportByUnitsRowsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "classIds"
},
v1 = {
  "defaultValue": true,
  "kind": "LocalArgument",
  "name": "skip"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "standardStateId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "targetGroupId"
},
v4 = [
  {
    "condition": "skip",
    "kind": "Condition",
    "passingValue": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "classIds",
            "variableName": "classIds"
          },
          {
            "kind": "Variable",
            "name": "standardStateId",
            "variableName": "standardStateId"
          },
          {
            "kind": "Variable",
            "name": "targetGroupId",
            "variableName": "targetGroupId"
          }
        ],
        "concreteType": "ExportableReport",
        "kind": "LinkedField",
        "name": "transposedSkillProgressReportGroupedByUnitsInBytes",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "data",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ReportHubDetailedSkillReportByUnitsRowsQuery",
    "selections": (v4/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "ReportHubDetailedSkillReportByUnitsRowsQuery",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "586fdc155d514adf2d2211de8c689649",
    "id": null,
    "metadata": {},
    "name": "ReportHubDetailedSkillReportByUnitsRowsQuery",
    "operationKind": "query",
    "text": "query ReportHubDetailedSkillReportByUnitsRowsQuery(\n  $classIds: [ID!]!\n  $targetGroupId: ID!\n  $standardStateId: ID!\n  $skip: Boolean = true\n) {\n  transposedSkillProgressReportGroupedByUnitsInBytes(classIds: $classIds, targetGroupId: $targetGroupId, standardStateId: $standardStateId) @skip(if: $skip) {\n    data\n  }\n}\n"
  }
};
})();

(node as any).hash = "8845b4fc080466947d1472e6f1dcabb2";

export default node;
